import React, { useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import '../styles/termspage.css';

export default function TermsOfServicePage() {

       // Scroll to top on mount
      useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      }, []);
      
  return (
    <>
      <MetaTags>
        <title>Terms of Service — PolyQuizz</title>
        <meta name="description" content="Terms of Service for PolyQuizz by PolyLearning Edu." />
      </MetaTags>

      

      <main className="terms-hero">
        <div className="terms-container">
          <header className="terms-header">
            <h1>Terms of Service</h1>
            <p className="terms-sub">These terms govern your use of PolyQuizz and related services provided by PolyLearning Edu.</p>
            <p className="terms-meta">Last updated: October 2025</p>
          </header>

          <section className="terms-section">
            <h2>1. User eligibility</h2>
            <p>
              By using PolyQuizz you confirm the information you provide is accurate and that you are at least 13 years old (or using the Site
              with parental consent if you are under 18). Use is void where prohibited by law.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Acceptable use</h2>
            <p>
              You are responsible for your account activity and any Content you post. Do not post unlawful, harmful, offensive, or abusive
              material. Automated scraping, hacking, or attempts to disrupt the service are prohibited. We may remove content or suspend accounts
              that violate these terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. Ownership & content rights</h2>
            <p>
              When you upload content to PolyQuizz you grant PolyLearning Edu a non-exclusive, royalty-free, worldwide license to use and display
              that content to operate and improve the Site. All original materials on PolyQuizz (quizzes, text, graphics) are protected by
              copyright and may not be reused without permission.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. Third-party content & advertising</h2>
            <p>
              The Site may include links, ads, or content supplied by third parties. We do not endorse or guarantee those materials; any
              transaction with a third party is solely between you and that third party.
            </p>
          </section>

          <section className="terms-section">
            <h2>5. Account access & administration</h2>
            <p>
              Authorized PolyLearning Edu personnel may access your account to provide support, enforce these Terms, or maintain security.
              Such access is performed in accordance with our Privacy Policy.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Privacy</h2>
            <p>
              Our <a href="/privacy-policy">Privacy Policy</a> describes how we collect and use personal data. By using PolyQuizz you accept the
              practices described in that policy.
            </p>
          </section>

          {/* <section className="terms-section">
            <h2>7. Payments & refunds</h2>
            <p>
              Paid features are clearly labeled. Refunds are handled according to our <a href="/refund-policy">Refund Policy</a>. By making a
              purchase you agree to that policy.
            </p>
          </section> */}

          <section className="terms-section">
            <h2>8. Copyright & DMCA</h2>
            <p>
              We respect intellectual property. If you believe your copyright has been infringed, contact <a href="mailto:support@polyquizz.com">support@polyquizz.com</a>.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Disclaimers</h2>
            <p>
              The Site and its content are provided "as is" and "as available." We make no warranties about accuracy, uptime, or suitability for
              a particular purpose. Your use is at your own risk.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Limitation of liability</h2>
            <p>
              PolyLearning Edu and its affiliates are not liable for indirect or consequential damages. Our total liability for any claim related
              to the Site will not exceed INR 500 (or $9.99 USD), to the extent permitted by law.
            </p>
          </section>

          <section className="terms-section">
            <h2>11. Indemnification</h2>
            <p>
              You agree to indemnify and hold PolyLearning Edu harmless from claims or losses arising from your use of the Site or violation of
              these Terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>12. Governing law & changes</h2>
            <p>
              These Terms are governed by the laws of India and disputes are subject to courts in Pune, Maharashtra. We may update these Terms;
              continued use of the Site after changes means you accept them.
            </p>
          </section>

          <footer className="terms-contact">
            <p>
              Questions? Contact PolyLearning Edu at <a href="mailto:support@polyquizz.com">support@polyquizz.com</a>.
            </p>
          </footer>
        </div>
      </main>

    </>
  );
}
